<script setup lang="ts">
import type { PropertyOnPage } from '@@/shared/property/api-types';

withDefaults(defineProps<{
  property: PropertyOnPage
  titleTag?: 'p' | 'h2' | 'h3'
}>(), {
  titleTag: 'h2',
});

const emit = defineEmits<{
  share: []
  contact: []
}>();

const isDialogMapOpen = defineModel<boolean>({ default: false });
</script>

<template>
  <section
    v-if="property.location.hasMapInfo"
    class="pt-2xl flex flex-col gap-m"
  >
    <IadTitle
      :tag="titleTag"
      :text="`${property.location.place} (${property.location.postcode})`"
    />
    <IadMapImage
      class="w-full cursor-pointer"
      :longitude="property.location.longitude"
      :latitude="property.location.latitude"
      :display-pin="property.location.displayPin"
      @click="isDialogMapOpen = true"
    />
    <ClientOnly>
      <PropertyDialogMap
        v-model="isDialogMapOpen"
        :property
        :display-pin="property.location.displayPin"
        @share="emit('share')"
        @contact="emit('contact')"
      />
    </ClientOnly>
  </section>
</template>
